module.exports = __webpack_public_path__ + "img/doc.d05a1beb.svg";